import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-alert-notification',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './alert-notification.component.html',
  styleUrl: './alert-notification.component.scss'
})
export class AlertNotificationComponent {
  @Input() type!: string;
  @Input() iconClass!: string;
  @Input() text!: string;
}
